module.exports = "/images/arrow-up.png?3a8507223933cf38146375ae23d7ca08";